import { render } from "./Address.vue?vue&type=template&id=e9b7f222"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import exportComponent from "D:\\srv\\vhost\\f-cat-app\\frontend\\musicbizz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__